import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const labelCls =
  "text-zinc-500 text-xs font-bold uppercase tracking-[0.15em]";
const inputCls =
  "mt-1 bg-[#0A0A0A] border-[#262626] focus:border-[#007AFF] text-white";
const textareaCls = `${inputCls} min-h-[80px] resize-none`;

export default function AnamnesiLifestyleSection({ form, onChange }) {
  return (
    <>
      <p className="label-overline mb-3">STILE DI VITA</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        <div>
          <Label className={labelCls}>Stile di vita</Label>
          <Textarea
            value={form.lifestyle}
            onChange={(e) => onChange("lifestyle", e.target.value)}
            className={textareaCls}
            data-testid="anamnesi-lifestyle"
          />
        </div>
        <div>
          <Label className={labelCls}>Note aggiuntive</Label>
          <Textarea
            value={form.notes}
            onChange={(e) => onChange("notes", e.target.value)}
            className={textareaCls}
            data-testid="anamnesi-notes"
          />
        </div>
      </div>

      <p className="label-overline mb-3">SONNO, MOTIVAZIONE E ASPETTATIVE</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <div>
          <Label className={labelCls}>Qualita del sonno</Label>
          <Select
            value={form.sleep_quality || "unset"}
            onValueChange={(v) => onChange("sleep_quality", v === "unset" ? "" : v)}
          >
            <SelectTrigger
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="anamnesi-sleep_quality"
            >
              <SelectValue placeholder="Seleziona" />
            </SelectTrigger>
            <SelectContent className="bg-[#171717] border-[#262626]">
              <SelectItem value="unset" className="text-white">-</SelectItem>
              <SelectItem value="ottima" className="text-white">Ottima</SelectItem>
              <SelectItem value="buona" className="text-white">Buona</SelectItem>
              <SelectItem value="sufficiente" className="text-white">Sufficiente</SelectItem>
              <SelectItem value="scarsa" className="text-white">Scarsa</SelectItem>
              <SelectItem value="pessima" className="text-white">Pessima</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className={labelCls}>Ore di sonno</Label>
          <Input
            value={form.sleep_hours}
            onChange={(e) => onChange("sleep_hours", e.target.value)}
            className={inputCls}
            placeholder="es. 7-8 ore"
            data-testid="anamnesi-sleep_hours"
          />
        </div>
        <div className="sm:col-span-2 lg:col-span-1">
          <Label className={labelCls}>Livello di motivazione</Label>
          <Select
            value={form.motivation || "unset"}
            onValueChange={(v) => onChange("motivation", v === "unset" ? "" : v)}
          >
            <SelectTrigger
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="anamnesi-motivation"
            >
              <SelectValue placeholder="Seleziona" />
            </SelectTrigger>
            <SelectContent className="bg-[#171717] border-[#262626]">
              <SelectItem value="unset" className="text-white">-</SelectItem>
              <SelectItem value="molto_alta" className="text-white">Molto alta</SelectItem>
              <SelectItem value="alta" className="text-white">Alta</SelectItem>
              <SelectItem value="media" className="text-white">Media</SelectItem>
              <SelectItem value="bassa" className="text-white">Bassa</SelectItem>
              <SelectItem value="molto_bassa" className="text-white">Molto bassa</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4">
        <div>
          <Label className={labelCls}>Aspettative</Label>
          <Textarea
            value={form.expectations}
            onChange={(e) => onChange("expectations", e.target.value)}
            className={textareaCls}
            placeholder="Cosa si aspetta dal percorso, obiettivi a breve e lungo termine..."
            data-testid="anamnesi-expectations"
          />
        </div>
      </div>
    </>
  );
}
